module.exports = __webpack_public_path__ + "img/magistr.90665613.jpg";